/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Sub_Spend_Already_InvoicedInputs */



/**
* | output |
* | --- |
* | "Already invoiced" |
*
* @param {Gateway_Sub_Spend_Already_InvoicedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_sub_spend_already_invoiced = /** @type {((inputs?: Gateway_Sub_Spend_Already_InvoicedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Sub_Spend_Already_InvoicedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bereits abgerechnet")
	return /** @type {LocalizedString} */ ("Already invoiced")
});